import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

import { INITIAL_SAFETY_EVENT_HISTORY_STATE } from './safetyEventHistorySlice.model';
import { SAFETY_EVENT_HISTORY_REDUCERS } from './safetyEventHistorySlice.reducers';

const {
  reduceSetSafetyEventHistorySession,
  reduceResetSafetyEventHistorySession,
} = SAFETY_EVENT_HISTORY_REDUCERS;

/**
 * Session-scoped view state for the safety event history list.
 *
 * Data itself comes from RTK Query, so this slice only carries what the user
 * picked: filters, search, page index and the continuation tokens needed to
 * re-request a page.
 */
export const safetyEventHistorySlice = createSlice({
  name: 'safetyEventHistory',
  initialState: INITIAL_SAFETY_EVENT_HISTORY_STATE,
  reducers: {
    setSafetyEventHistorySession: reduceSetSafetyEventHistorySession,
    resetSafetyEventHistorySession: reduceResetSafetyEventHistorySession,
  },
  extraReducers: (builder) => {
    // Reset state when the persist store is purged on logout. The usual logout
    // reloads the app, but the logout error path purges and routes to login
    // inside the same SPA, which would otherwise leave one user's filters,
    // search, page and cursors in memory for the next login.
    builder.addCase(PURGE, () => INITIAL_SAFETY_EVENT_HISTORY_STATE);
  },
});

export const { setSafetyEventHistorySession, resetSafetyEventHistorySession } =
  safetyEventHistorySlice.actions;

export const safetyEventHistoryReducer = safetyEventHistorySlice.reducer;
